import { ClaimDocumentFileDownloadUseCase } from '../../../application';

export default class ClaimDocumentFileDownloadService {
    constructor() {}

    async execute(event) {
        const request = await ClaimDocumentFileDownloadUseCase(event);

        return request;
    }
}
